var map = {
	"./custom/app/shared/dso-selector/modal-wrappers/create-item-parent-selector/create-item-parent-selector.component": [
		51965,
		[
			"default-src_app_shared_dso-selector_dso-selector_authorized-collection-selector_authorized-co-32e940",
			"common",
			"src_themes_custom_app_shared_dso-selector_modal-wrappers_create-item-parent-selector_create-i-f7c57c"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 25074;
module.exports = webpackAsyncContext;